// extracted by mini-css-extract-plugin
export default {"wrapper":"dlgTtIKtVnr2hy7C6h4n","percent":"M4PA4AwlsCu7oIANwFEw","amount":"S_AKnYWMR6Jb0geglHIP"};